import * as _ from 'lodash';
import { Modal } from 'react-bootstrap';
import { IBloodDrawConfirmationContract, ICoordinatorListByCenter, IDonorWithMSRecipientUpdated, IListItem, ILogistics, IPosition } from '@nkr/models/index';
import { ActionItem } from '../../models';
import {
    MatchOffers, DonorCompliance, RecipientCompliance, LogisticsKickoffCalls, TransplantPickup,
    TransplantDelivery, XmTracking, RequestForDonorReview, AdpMissingVoucherHolders,
    Donors, VoucherDonors, RemoteWorkupsNotBilled, PreselectsByCenter,
    CenterContactPositionsList, ConfirmSerologyBloodDraw, ConfirmBloodDrawCompletion
} from '.';
import { Button } from 'react-bootstrap';
import { MainType } from '../models/main-type';
import OutstandingInternalDirectSwaps from './outstanding-internal-direct-swaps';
import MissingVoucherConsents from './missing-voucher-consents';
import MicrositeCompliance from './microsite-compliance';
import AbWaitListPatients from './ab-waitlist-patients';
import DashToDo from './dash-to-do';
import DonorsMissingLdPriorization from './donors-missing-ld-priorization';
import PendingPatientIntakeReferrals from './pending-patient-intake-referrals';

interface IProps {
    show: boolean,
    type: ActionItem,
    title: string,
    items: any[],
    logistics: ILogistics,
    coordinators: ICoordinatorListByCenter[],
    remoteStatus: IListItem[],
    centerId: number,
    mainType: MainType,
    onGetLogistics: (swap: IPosition) => Promise<any>,
    onUploadFinalXm: (donorId: number, recipientId: number, acceptable: number, rootCause: string, correctiveAction: string, initials: string, upload: File) => void,
    onUpdateInternalDirect: (id: number, donationDate: string, action: number) => void,
    onConfirmBloodDraw: (contract: IBloodDrawConfirmationContract) => void,
    onConfirmBloodDrawCompletion: (contract: IBloodDrawConfirmationContract) => void,
    onSave: (updatedList: IDonorWithMSRecipientUpdated[]) => void,
    onClose: () => void
}

const ToDoList = (props: IProps) => {
    const handleClose = () => {
        props.onClose();
    };

    const handleGetLogistics = (swap: IPosition): Promise<any> => {
        return props.onGetLogistics(swap);
    };

    const isRecipientDataCompliance = [
        ActionItem.ActiveRecipientDataCompliance,
        ActionItem.PostTransplantRecipientDataCompliance
    ].indexOf(props.type) >= 0;

    const isDonorDataCompliance = [
        ActionItem.ActiveDonorDataCompliance,
        ActionItem.ActiveRdnDonorDataCompliance,
        ActionItem.PostTransplantDonorDataCompliance,
        ActionItem.PostTransplantRdnDonorDataCompliance
    ].indexOf(props.type) >= 0;

    const isPostTransplantDonorDataCompliance = [
        ActionItem.PostTransplantDonorDataCompliance,
        ActionItem.PostTransplantRdnDonorDataCompliance
    ].indexOf(props.type) >= 0;

    return (
        <Modal show={props.show} bsSize='lg' backdrop='static' onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {(props.type == ActionItem.MatchOffers || props.type == ActionItem.DonorClearance) && (
                    <MatchOffers
                        list={props.items}
                        centerId={props.centerId}
                    />
                )}

                {isDonorDataCompliance && (
                    <DonorCompliance
                        list={props.items}
                        centerId={props.centerId}
                        isPostTransplant={isPostTransplantDonorDataCompliance}
                    />
                )}

                {isRecipientDataCompliance && (
                    <RecipientCompliance
                        list={props.items}
                        centerId={props.centerId}
                        isPostTxp={props.type == ActionItem.PostTransplantRecipientDataCompliance}
                    />
                )}

                {props.type == ActionItem.LogisticsKickoffCalls && (
                    <LogisticsKickoffCalls
                        list={props.items}
                        centerId={props.centerId}
                    />
                )}

                {props.type == ActionItem.TransplantPickup && (
                    <TransplantPickup
                        list={props.items}
                        logistics={props.logistics}
                        onGetLogistics={handleGetLogistics}
                    />
                )}

                {props.type == ActionItem.TransplantDelivery && (
                    <TransplantDelivery
                        list={props.items}
                        logistics={props.logistics}
                        onGetLogistics={handleGetLogistics}
                    />
                )}

                {(props.type == ActionItem.XMResults || props.type == ActionItem.FinalXmReults) && (
                    <XmTracking
                        list={props.items}
                        centerId={props.centerId}
                        onUploadFinalXm={props.onUploadFinalXm}
                    />
                )}

                {props.type == ActionItem.RequestForDonorReview && (
                    <RequestForDonorReview
                        list={props.items}
                        urgent={props.mainType == MainType.ToDo}
                    />
                )}

                {/* {props.type == ActionItem.DashContactDue && (
                    <DashContactsDue
                        list={props.items}
                        centerId={props.centerId}
                    />
                )} */}

                {props.type == ActionItem.MissingVoucherHolders && (
                    <AdpMissingVoucherHolders
                        list={props.items}
                    />
                )}

                {(props.type == ActionItem.DonationDateRangeConflict || props.type == ActionItem.DonorEval || props.type == ActionItem.FlaggedForVoucherDonation) && (
                    <Donors
                        list={props.items}
                        type={props.type}
                    />
                )}

                {props.type == ActionItem.VoucherDonors && (
                    <VoucherDonors
                        list={props.items}
                        centerId={props.centerId}
                    />
                )}

                {props.type == ActionItem.RemoteWorkupsNotBilled && (
                    <RemoteWorkupsNotBilled
                        list={props.items}
                    />
                )}

                {props.type == ActionItem.OutstandingInternalDirectSwaps && (
                    <OutstandingInternalDirectSwaps
                        list={props.items}
                        onSubmit={props.onUpdateInternalDirect}
                    />
                )}

                {props.type == ActionItem.MissingVoucherConsents && (
                    <MissingVoucherConsents
                        list={props.items}
                        centerId={props.centerId}
                    />
                )}

                {props.type == ActionItem.MicrositeDataCompliance && (
                    <MicrositeCompliance
                        list={props.items}
                        centerId={props.centerId} />
                )}

                {props.type == ActionItem.Preselects && (
                    <PreselectsByCenter list={props.items} />
                )}

                {props.type == ActionItem.HasAbWaitListPatients && (
                    <AbWaitListPatients list={props.items} />
                )}

                {props.type == ActionItem.DashContactDue && (
                    <DashToDo list={props.items} />
                )}

                {props.type == ActionItem.LdPrioritization &&
                    <DonorsMissingLdPriorization list={props.items} />
                }

                {props.type == ActionItem.PendingPatientIntakeReferrals &&
                    <PendingPatientIntakeReferrals list={props.items} />
                }

                {props.type == ActionItem.CenterContactPositions &&
                    <CenterContactPositionsList list={props.items} />
                }

                {props.type == ActionItem.ConfirmSerologyBloodDraw &&
                    <ConfirmSerologyBloodDraw
                        list={props.items}
                        onConfirm={props.onConfirmBloodDraw}
                    />
                }

                {props.type == ActionItem.ConfirmBloodDrawCompletion &&
                    <ConfirmBloodDrawCompletion
                        list={props.items}
                        onConfirm={props.onConfirmBloodDrawCompletion}
                    />
                }
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ToDoList;